// 手持身份证上传
<template>
    <div class="idCardUpload">
        <div class="instructions">
            <div class="img"><img :src="bg" /></div>
            <div class="content_box">
                <h3>Tips for uploading documents</h3>
                <ul>
                    <li>Image must be clear and sharp</li>
                    <li v-if="isIdCard">Capture full details of your IDs, make sure it is not blocked by shadows or fingers</li>
                    <li v-else>Make sure the document is not blocked by shadows or fingers</li>
                    <li>File must be in JPG, JPEG, PNG, or PDF format</li>
                </ul>
            </div>
        </div>
        <div class="uploadBox" v-if="isIdCard">
            <div class="title">Selfie with ID</div>
            <div class="upload margin-top">
                <OnePhoto @uploadData="getImgData" :img="photoData.idCardiUrl" />
            </div>
            <div class="sample">
                <p class="tip">Make sure both your face and ID are clear and visible</p>
                <div class="img"><img src="@/assets/pc/Rectangle.png" /></div>
            </div>
        </div>
        <div class="uploadBox" v-if="isDTI">
            <div class="upload">
                <MorePhoto title="Photo of DTI Certificate" @imgData="dit" :img="photoData.dtiUrl" />
            </div>
            <div class="sample">
                <p class="tip">Sample photo for DTI Certificate</p>
                <div class="img"><img src="@/assets/pc/dti.png" /></div>
            </div>
        </div>
        <div class="uploadBox" v-if="isSec">
            <div class="upload">
                <MorePhoto title="Photo of SEC Certificate" @imgData="sec" :img="photoData.secUrl" :exceedNumber="30" />
            </div>
            <div class="sample">
                <p class="tip">Sample photo for SEC Certificate</p>
                <div class="img"><img src="@/assets/pc/sec.png" /></div>
            </div>
        </div>
        <div v-if="isStore">
            <div class="uploadBox border-bottom">
                <div class="upload">
                    <MorePhoto title="Store Photo (Exterior)" :uploadNumber="0" @imgData="exterior" :img="photoData.exterior" />
                </div>
                <div class="sample">
                    <p class="tip">Sample photo for Store (Exterior)</p>
                    <div class="img"><img src="@/assets/pc/store1.jpg" /></div>
                </div>
            </div>
            <div class="uploadBox">
                <div class="upload">
                    <MorePhoto title="Store Photo (Interior)" :uploadNumber="1" @imgData="interior" :img="photoData.interior" />
                </div>
                <div class="sample">
                    <p class="tip">Sample photo for Store (Interior)</p>
                    <div class="img"><img src="@/assets/pc/store2.jpg" /></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import OnePhoto from "../../components/OnePhotoUpload.vue";
import MorePhoto from "../../components/MorePhotoUpload.vue";
export default {
    name: "IdCardUpload",
    props: {
        photoType: {
            type: String,
            default: "idCard"
        },
        photoData: {
            type: Object,
            default: () => ({})
        }
    },
    components: {
        OnePhoto,
        MorePhoto
    },
    data() {
        return {
            bg: require("@/assets/cardinfo.png"),
            ditImg: '',
            secImg: '',
            exteriorImg: [],
            interiorImg: [],
        }
    },
    computed: {
        isIdCard() {
            return this.photoType === "idCard"
        },
        isDTI() {
            return this.photoType === "DTI"
        },
        isSec() {
            return this.photoType === "sec"
        },
        isStore() {
            return this.photoType === "store"
        },
        storePhoto() {
            return this.exteriorImg.length + this.interiorImg.length
        }
    },
    watch: {
        storePhoto:function() {
            this.$emit('exteriorImg', this.exteriorImg)
            this.$emit('interiorImg', this.interiorImg)
        }
    },
    methods: {
        getImgData(val) {
            this.$emit('uploadData', val)
        },
        dit(val) {
            // 服务端限制只能传字符串，改成以逗号拼接的字符串，不传数组
            this.ditImg = val.join(',')
            this.$emit('ditImg', this.ditImg)
        },
        sec(val) {
            // 服务端限制只能传字符串，改成以逗号拼接的字符串，不传数组
            this.secImg = val.join(',')
            this.$emit('secImg', this.secImg)
        },
        exterior(val) {
            this.exteriorImg = val
        },
        interior(val) {
            this.interiorImg = val
        }
    }
}
</script>
<style lang="scss" scoped>
.idCardUpload {
    width: 100%;
    .instructions {
        overflow: hidden;
        height: 150px;
        border-bottom: 1px solid #E4E4E4;
        & > div {
            float: left;
        }
        .img {
            width: 229px;
            margin: 0 42px 0 68px;
            img {
                width: 100%;
            }
        }
        .content_box {
            width: 369px;
            h3 {
                font: normal normal normal 16px/24px Nunito-bold;
            }
            ul {
                margin-left: -21px;
                li {
                    list-style-type: disc;
                }
            }
        }
    }
    .uploadBox {
        overflow: hidden;
        margin: 32px 0 14px;
        .title {
          color: #004EA8;
          font: normal normal normal 16px/24px Nunito-bold;
        }
        .sample {
          float: left;
          width: 50%;
          p, .tip {
            color: #656565;
            font-size: 16px;
            text-align: left;
            line-height: 22px;
            margin-bottom: 0;
          }
          .img {
            height: 216px;
            overflow: hidden;
            border-radius: 8px;
            margin-top: 16px;
            background-color: #F3F3F3;
            padding: 9px 15px;
            box-sizing: border-box;
            img {
              width: 100%;
              height: 197px;
              float: right;
            }
          }
        }
        .upload {
          float: left;
          width: 50%;
          font: normal normal normal 14px/24px Nunito;
          margin-bottom: 6px;
          &.margin-top {
            margin-top: 30px;
          }
        }
    }
    .border-bottom {
      border-bottom: 1px solid #E8E8E8;
    }
}
</style>